import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'
import AddContact from './AddContact'
import UpdateContact from './UpdateContact'
import LoginRequest from './LoginRequest'

function Contacts(props) {
  props.stopListRefresh()
  const [isOpen, setIsOpen] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [selected, setSelected] = useState({})
  //const [isloggedIn, setIsloggedIn] = useState(true);
  /* const [query, setQuery] = useState(""); */
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  /* useEffect(() => {
        const fetchLogin = async () => {
            if (userToken === null) {
                console.log("kirjaudu sisään")
                setIsloggedIn(false)
            }
        }
        fetchLogin();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

  const togglePopUp = async () => {
    setIsOpen(!isOpen)
  }

  const toggleEditMode = (contactData, index) => {
    let tempContact = { contactData: contactData, index: index }
    setIsEditMode(!isEditMode)
    setSelected({ tempContact })
  }

  const removeData = async (contactId) => {
    try {
      await axios.delete(`${SERVER_URI}/remove_contact/${contactId}`, {
        headers: { Authorization: `Token ${userToken}` },
      })
    } catch (e) {
      console.log('Error in deleting the contact', e)
    }
    props.dispatch({ type: 'DELETE_CONTACT', data: { contactId: contactId } })
  }

  return (
    <div className='configurations'>
      {isOpen && (
        <AddContact dispatch={props.dispatch} handleClose={togglePopUp} />
      )}
      {isEditMode && (
        <UpdateContact
          dispatch={props.dispatch}
          handleClose={toggleEditMode}
          data={selected.tempContact}
        />
      )}
      <h3>Yhteystiedot</h3>
      <span>
        <div className='discountRates'>
          <button id='lightBlue_button' onClick={togglePopUp}>
            Lisää yhteystieto
          </button>
          {props.contactsList === undefined ? (
            <LoginRequest />
          ) : props.contactsList.length === 0 ? (
            <h4>Ei kontakteja</h4>
          ) : (
            <table id='contactTable'>
              <thead>
                <tr>
                  <th>Nimi</th>
                  <th>Puhelinnumero</th>
                  <th>Sähköposti</th>
                </tr>
              </thead>
              <tbody>
                {props.contactsList.map((contactsList, index) => (
                  <tr key={contactsList.id} id={contactsList.id}>
                    <td>{contactsList.name}</td>
                    <td>{String(contactsList.phoneNumber)}</td>
                    <td>{contactsList.email}</td>

                    <td className='operation'>
                      <button onClick={() => removeData(contactsList.id)}>
                        Poista
                      </button>
                      <button
                        onClick={() => toggleEditMode(contactsList, index)}
                      >
                        Muokkaa
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </span>
    </div>
  )
}

export default Contacts
